import { get, del, post, put } from '@api/request';

export async function fetchModels(
  { appraisalService },
  authenticationToken,
  { modelType, selectedYear },
) {
  const url = `${appraisalService}/appraisal/models?modelType=${modelType}&modelYr=${selectedYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteModel(
  { appraisalService },
  authenticationToken,
  { modelID },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertModel(
  { appraisalService },
  authenticationToken,
  { modelType, modelName, modelCode, modelYr },
) {
  const url = `${appraisalService}/appraisal/models`;
  const { body } = await post(authenticationToken, url, {
    modelType,
    modelName,
    modelCode,
    modelYr,
  });
  return body;
}

export async function duplicateModel(
  { appraisalService },
  authenticationToken,
  { modelID },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function updateModel(
  { appraisalService },
  authenticationToken,
  { modelName, modelCode, modelID, updateDt },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}`;
  const { body } = await put(authenticationToken, url, {
    modelName,
    modelCode,
    lastUpdate: updateDt,
  });

  return body;
}

export async function fetchModel(
  { appraisalService },
  authenticationToken,
  { modelID },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}`;
  const { body } = await get(authenticationToken, url);

  return body;
}
// Adjustments
export async function fetchAdjustments(
  { appraisalService },
  authenticationToken,
  { modelYr, segmentType },
) {
  const url = `${appraisalService}/appraisal/model/adjustments?modelYr=${modelYr}&segmentType=${segmentType}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertAdjustment(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/model/adjustments`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function deleteAdjustments(
  { appraisalService },
  authenticationToken,
  { modelAdjustID },
) {
  const url = `${appraisalService}/appraisal/model/adjustment/${modelAdjustID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function updateAdjustment(
  { appraisalService },
  authenticationToken,
  { modelAdjustID, payload },
) {
  const url = `${appraisalService}/appraisal/model/adjustment/${modelAdjustID}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

// module features

export async function fetchModelFeatures(
  { appraisalService },
  authenticationToken,
  { modelID },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}/features`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertModelFeature(
  { appraisalService },
  authenticationToken,
  { modelID, payload },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}/features`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function deleteModelFeature(
  { appraisalService },
  authenticationToken,
  { modelFeatureID },
) {
  const url = `${appraisalService}/appraisal/model/feature/${modelFeatureID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

// features
export async function fetchFeatures(
  { appraisalService },
  authenticationToken,
  { year },
) {
  const url = `${appraisalService}/appraisal/features?featureYr=${year}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertFeature(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/features`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function deleteFeature(
  { appraisalService },
  authenticationToken,
  { featureID },
) {
  const url = `${appraisalService}/appraisal/feature/${featureID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function updateFeatureCode(
  { appraisalService },
  authenticationToken,
  { featureCodeID, payload },
) {
  const url = `${appraisalService}/appraisal/feature/code/${featureCodeID}`;
  const { body } = await put(authenticationToken, url, {
    ...payload,
    lastUpdate: payload.updateDt,
  });

  return body;
}

export async function insertFeatureCode(
  { appraisalService },
  authenticationToken,
  { featureID, payload },
) {
  const url = `${appraisalService}/appraisal/feature/${featureID}/codes`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function fetchTypes({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/modeladjustments/uicodes`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchFeatureTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/models/uicodes`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchFeatureCodes(
  { appraisalService },
  authenticationToken,
  { featureID },
) {
  const url = `${appraisalService}/appraisal/feature/${featureID}/codes`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function deleteFeatureCode(
  { appraisalService },
  authenticationToken,
  { featureCodeID },
) {
  const url = `${appraisalService}/appraisal/feature/code/${featureCodeID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function fetchPricingComponents(
  { appraisalService },
  authenticationToken,
  { modelID },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}/components`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function deletePricingComponents(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}`;
  const { body } = await del(authenticationToken, url);

  return body;
}

export async function fetchAreaTypes(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/models/areatypes`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchCodefile(
  { appraisalService },
  authenticationToken,
  { type, name },
) {
  const url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function setAsBase(
  { appraisalService },
  authenticationToken,
  { modelComponentID, updateDt },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/setbasecomponent`;
  const { body } = await put(authenticationToken, url, {
    lastUpdate: updateDt,
  });

  return body;
}

export async function insertPricingComponents(
  { appraisalService },
  authenticationToken,
  { modelID, payload },
) {
  const url = `${appraisalService}/appraisal/model/${modelID}/components`;
  const { body } = await post(authenticationToken, url, payload);

  return body;
}

export async function updatePricingComponents(
  { appraisalService },
  authenticationToken,
  { modelComponentID, payload },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function updateComponentTypes(
  { appraisalService },
  authenticationToken,
  { modelComponentID, payload },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/componenttypes`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function fetchSchedulesDetailPricing(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/detailpricing`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchDetailedFixedIncrementAdjustments(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/detailfixedincrementadjustments`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchSchedulesUnitCost(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/unitcostadjustments`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchSchedulesIncrementCost(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/fixedincrementadjustments`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function fetchSchedulesDepreciation(
  { appraisalService },
  authenticationToken,
  { modelComponentID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/depreciation`;
  const { body } = await get(authenticationToken, url);

  return body;
}

export async function insertSchedulesDetailPricing(
  { appraisalService },
  authenticationToken,
  { modelComponentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/detailpricing`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}

export async function insertDetailedFixedIncrementAdjustments(
  { appraisalService },
  authenticationToken,
  { modelComponentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/detailfixedincrementadjustments`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}

export async function insertSchedulesUnitCost(
  { appraisalService },
  authenticationToken,
  { modelComponentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/unitcostadjustments`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}

export async function insertSchedulesIncrementCost(
  { appraisalService },
  authenticationToken,
  { modelComponentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/fixedincrementadjustments`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}

export async function insertSchedulesDepreciation(
  { appraisalService },
  authenticationToken,
  { modelComponentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/depreciation`;
  const { body } = await post(authenticationToken, url, { pricingID });

  return body;
}

export async function deleteSchedulesDetailPricing(
  { appraisalService },
  authenticationToken,
  { modelComponentDetailPricingID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/detailpricing/${modelComponentDetailPricingID}`;
  const { body } = await del(authenticationToken, url, { pricingID });

  return body;
}

export async function deleteDetailedFixedIncrementAdjustments(
  { appraisalService },
  authenticationToken,
  { modelComponentDetailFixedIncrementAdjustmentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/detailfixedincrementadjustment/${modelComponentDetailFixedIncrementAdjustmentID}`;
  const { body } = await del(authenticationToken, url, { pricingID });

  return body;
}


export async function deleteSchedulesUnitCost(
  { appraisalService },
  authenticationToken,
  { modelComponentUnitCostAdjustmentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/unitcostadjustment/${modelComponentUnitCostAdjustmentID}`;
  const { body } = await del(authenticationToken, url, { pricingID });

  return body;
}

export async function deleteSchedulesIncrementCost(
  { appraisalService },
  authenticationToken,
  { modelComponentFixedIncrementAdjustmentID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/fixedincrementadjustment/${modelComponentFixedIncrementAdjustmentID}`;
  const { body } = await del(authenticationToken, url, { pricingID });

  return body;
}

export async function deleteSchedulesDepreciation(
  { appraisalService },
  authenticationToken,
  { modelComponentDepreciationID, pricingID },
) {
  const url = `${appraisalService}/appraisal/model/component/depreciation/${modelComponentDepreciationID}`;
  const { body } = await del(authenticationToken, url, { pricingID });

  return body;
}

export async function fetchPricingSchedules(
  { appraisalService },
  authenticationToken,
  { year, type, query },
) {
  let url = `${appraisalService}/appraisal/pricingschedules?year=${year}`;
  if (type) {
    url = `${url}&pricingType=${type}`;
  }
  if (query) {
    url = `${url}&${query}`;
  }
  const { body } = await get(authenticationToken, url);

  return body;
}
/**
  type = [setdepreciationorder, setunitcostadjustmentorder, setfixedincrementadjustmentorder, setdetailpricingorder]
 */
export async function setPricingOrder(
  { appraisalService },
  authenticationToken,
  { modelComponentID, orderList, type },
) {
  const url = `${appraisalService}/appraisal/model/component/${modelComponentID}/${type}`;
  const { body } = await put(authenticationToken, url, { orderList });

  return body;
}

export async function setBaseUnitCostAdjustment(
  { appraisalService },
  authenticationToken,
  { modelComponentUnitCostAdjustmentID, payload },
) {
  const url = `${appraisalService}/appraisal/model/component/unitcostadjustment/${modelComponentUnitCostAdjustmentID}/setincludeinbase`;
  const { body } = await put(authenticationToken, url, payload);

  return body;
}

export async function fetchRevisionHistory(
  { appraisalService },
  authenticationToken,
  { objectType, objectId },
) {
  const url = `${appraisalService}/appraisal/revisionhistory/pricing/${objectType}/${objectId}`;
  const { body } = await get(authenticationToken, url);

  return body;
}